import {
  SearchFilterBase,
  SearchFilterType,
} from '@aibees/elephant/feature/search-filters/types';
import { Maybe } from '@aibees/shared/definition';
import { useMemo } from 'react';

export function useClosedFilters(
  baseFilter: Maybe<SearchFilterBase>,
  openItemField?: string
) {
  return useMemo(
    () =>
      baseFilter?.items?.[0].items?.filter(
        (x) =>
          x.field !== openItemField &&
          x.type !== SearchFilterType.APPLIED_FILTERS
      ),
    [baseFilter?.items, openItemField]
  );
}
